<template>
  <GmapMap
    :center="center"
    :zoom="9" backgroundColor="#A52A2A"
    map-type-id="roadmap" :draggable="'false'" disableDoubleClickZoom="true" fullscreenControl="true"
    style="width: 210px; height: 125px"
  >
    <GmapMarker
      :key="index"
      v-for="(m, index) in markers"
      :position="m.position"
      :clickable="false"
      :draggable="false"
      @click="center=m.position"
    />
  </GmapMap>
</template>

<script>
    import Vue from 'vue';

    export default Vue.extend({
        name: 'UbicacionComponent',
        data() {
          return {
            markers: null,
            center: {lat: 0, lng: 0},
          }
        },
        beforeMount: function(){
          if (this.params.data.ubicacion.coordinates) {
            this.markers = [
              { position: {
                  lat: this.params.data.ubicacion.coordinates[1],
                  lng: this.params.data.ubicacion.coordinates[0]
                }
              }]
            this.center = this.markers[0].position
          }
        }
    });
</script>

<style >
</style>



// WEBPACK FOOTER //
// src/components/shared/UbicacionComponent.vue